<div class="tem-field content-container">
    <label class="tem-field-label">Informar o destino</label>
    <nz-select [formControl]="tabs" nzPlaceHolder="Informar o destino">
        <nz-option *ngFor="let item of options | async" [nzValue]="item" [nzLabel]="item"></nz-option>
    </nz-select>
</div>
<div class="options">
    <button nz-button nzDanger id="no-button" (click)="dialogRef.close(false)">Cancelar</button>
    <button nz-button nzType="primary" id="yes-button" [disabled]="tabs.invalid" (click)="salvar()">Selecionar</button>
</div>
